import { xCore } from './core';
import { NSFunctions } from './utils/functions';
import { Map as NSMap } from './map';
import {DragBox} from 'ol/interaction';
import { NSFeaturesSelect } from './map_features_select';
import SortDownIcon from 'bootstrap-icons/icons/sort-down.svg?raw';
import { NSPageLabels } from './page_labels';

export const NSObjectMultipleSelect = {}

NSObjectMultipleSelect.init = function() {
    NSObjectMultipleSelectPrivate.init();

    this.f_activate = function () { return NSObjectMultipleSelectPrivate.f_activate.apply( NSObjectMultipleSelectPrivate, arguments ); };
    this.f_deactivate = function () { return NSObjectMultipleSelectPrivate.f_deactivate.apply( NSObjectMultipleSelectPrivate, arguments ); };
    this.f_is_active = function () { return NSObjectMultipleSelectPrivate.f_is_active.apply( NSObjectMultipleSelectPrivate, arguments ); };
}

const NSObjectMultipleSelectPrivate = 
{
    o_interaction: null,
    b_is_active: false,
    init: function() {        
        const e_parent = document.querySelector("#header-actions-toolbar");
        const s_tooltip = NSPageLabels.f_get_label_text_by_internal_name('area_selection_tooltip');

        this.e_element = NSFunctions.f_dom_elem_append_dom_childs_by_html(e_parent, `
            <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-sm btn-outline-secondary" title="${s_tooltip}">
                    ${SortDownIcon}
                </button>
            </div>
        `);

        this.o_interaction = new DragBox({});

        this.f_init_listeners();
    },
    f_init_listeners: function() {
        let b_shift_key_start = false;

        this.e_element.querySelector('button').onclick = (evt) => {
            if (evt.currentTarget.classList.contains('active')) this.f_deactivate();
            else this.f_activate(); 
        };

        this.o_interaction.on('boxstart', (evt) => {
           b_shift_key_start = evt.mapBrowserEvent.originalEvent.shiftKey;
        });

        this.o_interaction.on('boxend', (evt) => {
            try {
                const a_bounding_box = this.o_interaction.getGeometry().getExtent(); 
                const b_shift_key_end = evt.mapBrowserEvent.originalEvent.shiftKey;
                const b_incremental = b_shift_key_start && b_shift_key_end;

                NSFeaturesSelect.f_request_features(a_bounding_box, b_incremental, false);
                
                b_shift_key_start = false;

                this.f_deactivate();
            } catch (err) {
                console.log('Failed on drawing box');
            }
        });
    },
    f_activate: function() {
        this.f_enable_events();
        this.b_is_active = true;
        this.e_element.querySelector('button').classList.add('active');
    },
    f_deactivate: function() {
        this.f_disable_events();
        this.b_is_active = false;
        this.e_element.querySelector('button').classList.remove('active');
    },
    f_enable_events: function() {
        NSMap.map.addInteraction(this.o_interaction);
    },
    f_disable_events: function() {
        NSMap.map.removeInteraction(this.o_interaction);
    },
    f_is_active: function() {
        return this.b_is_active;
    }
}
	